<ng-container *ngIf="loading">
  <div
    *ngIf="!promotion"
    #loadingRef
    class="l-page-loading"
    role="progressbar"
    tabindex="0"
    aria-valuemin="0"
    aria-valuemax="100"
    attr.aria-label="{{ 'alt.nowProcessing' | staticMsg }}"
  >
    <div class="l-page-loading__contents">
      <div id="page-loading-animation">
        <ng-lottie [options]="options"></ng-lottie>
      </div>
    </div>
  </div>

  <div
    #loadingPromotionRef
    *ngIf="promotion"
    class="l-page-loading02"
    role="progressbar"
    tabindex="0"
    aria-valuemin="0"
    aria-valuemax="100"
    attr.aria-label="{{ 'alt.nowProcessing' | staticMsg }}"
  >
    <div class="l-page-loading02__contents">
      <div class="l-wrap">
        <div class="l-wrap__inner">
          <div id="page-loading-animation02" class="l-page-loading02__icon">
            <ng-lottie [options]="optionsPromotion"></ng-lottie>
          </div>
          <p class="l-page-loading02__text" [innerHTML]="'message.informationDuringPromotion' | staticMsg"></p>
          <div class="l-page-loading02__promo">
            <div class="p-loading-fade-image">
              <ng-container *ngFor="let item of promotionImageList">
                <div class="p-loading-fade-image__item">
                  <picture class="p-loading-fade-image__picture">
                    <source [srcset]="item.imageUrls[0]" media="(max-width: 767px)" />
                    <source [srcset]="item.imageUrls[1]" media="(max-width: 1024px)" />
                    <img [src]="item.imageUrls[2]" [alt]="item.promotionAltMsgKey | staticMsg" />
                  </picture>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
